import { finalize, tap } from 'rxjs';
import { LOCALSTORAGE_KEYS } from '../constants/databases';
import { LocalStorageService } from '../local-storage.service';
import { PromotionsService } from '../promotions.service';
import { SignalsStoreService } from '../signals-store.service';
import { MarketingReferral } from '../types/common.types';

export const checkSignupCouponCodes = (data: {
    marketingReferral: MarketingReferral,
    signalsStoreService: SignalsStoreService,
    localStorageService: LocalStorageService,
    promotionsService: PromotionsService,
    showDefaultMessage: boolean
}) => {
    const { marketingReferral, signalsStoreService, localStorageService, promotionsService, showDefaultMessage } = data;

    signalsStoreService.setIsLoadedMarketingValidation(false);


    return promotionsService.getCouponInfo(marketingReferral, showDefaultMessage).pipe(
        tap((res) => {
            if (res?.name) {
                const promotionInfo = { code: marketingReferral.utmCampaign, name: res.name };
                signalsStoreService.setSignupPromotionInfo(promotionInfo);
                localStorageService.set(LOCALSTORAGE_KEYS.PROMOTION_INFO, promotionInfo)
                localStorageService.set(LOCALSTORAGE_KEYS.MARKETING_REFERRAL, marketingReferral);
            }
        }),
        finalize(() => {
            signalsStoreService.setIsLoadedMarketingValidation(true);
        })
    );
}